<template>
  <div class="wrapper">
    <div class="filter white_box">
      <!-- 第一行：员工姓名和薪资月份 -->
      <div class="filter-row-1">
        <!-- 搜索框 -->
        <el-input
          class="custom-es"
          size="medium"
          placeholder="请输入员工姓名/证件号码/手机号码"
          v-model="input"
          clearable
        ></el-input>
        <!-- 薪资月份 -->
        <div class="date-group">
          <p class="font_14_black">薪资月份：</p>
          <el-date-picker 
            v-model="salaryDateRange" 
            type="monthrange" 
            range-separator="至" 
            start-placeholder="开始月份" 
            end-placeholder="结束月份" 
            value-format="yyyy-MM"
            format="yyyy-MM"
          ></el-date-picker>
        </div>
      </div>
      
      <!-- 第二行：薪资类型和按钮 -->
      <div class="filter-row-2">
        <div class="tag-group">
          <p class="font_14_black">薪资类型：</p>
          <filter-tag
            :class="{active: setType['正常工资']}"
            @click.native="change('setType', '正常工资')"
            name="正常工资"
          />
          <filter-tag
            :class="{active: setType['劳务报酬']}"
            @click.native="change('setType', '劳务报酬')"
            name="劳务报酬"
          />
          <filter-tag
            :class="{active: setType['全年一次性奖金']}"
            @click.native="change('setType', '全年一次性奖金')"
            name="全年一次性奖金"
          />
          <filter-tag
            :class="{active: setType['解除劳动合同补偿金']}"
            @click.native="change('setType', '解除劳动合同补偿金')"
            name="解除劳动合同补偿金"
          />
        </div>
        <div class="button-group">
          <button-a color="#f26828" class="query" @click.native="query()">查询</button-a>
          <button-a color="#08a752" @click.native="reset()">重置</button-a>
          <button-a
              style="color: rgb(255, 255, 255); border-color: rgb(255, 255, 255); background-color: rgb(133, 207, 150);"
              @click.native="exportExcel()"
              :loading="exportLoading"
            >{{ exportLoading ? '正在导出中...' : '导出' }}</button-a>
        </div>
      </div>
    </div>

    <div class="result white_box">
      <!-- 标签筛选 -->
     
      <!-- 表格
        ref="multipleTable" 引用名
        :data="tableData" 绑定数据
        :header-row-style="headerRowStyle" 表头样式
        :row-style="rowStyle" 行样式
      -->
      <div v-loading="tableLoading" element-loading-text="加载中..." class="table-wrapper">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        :header-row-style="headerRowStyle"
        :header-cell-style="headerCellStyle"
        :row-style="rowStyle"
        style="width: 100%;font-size: 14px;color: #707070;border: 1px solid #e5e5e5;border-radius: 6px"
        @selection-change="handleSelectionChange"
        @row-click="handleRowClick"
        @row-dblclick="handleRowDblclick"
        @row-mousedown="handleRowMousedown"
        @row-mousemove="handleRowMousemove"
        @row-mouseup="handleRowMouseup"
      >
        <!-- 占位列 -->
        <el-table-column :width="tableWidth[0] | translateWidth"></el-table-column>
        <!-- 多选框 -->

        <el-table-column type="index" label="序号" width="54"></el-table-column>
        <el-table-column prop="customerName" label="所属企业" :width="tableWidth[1] | translateWidth" show-overflow-tooltip></el-table-column>
        <el-table-column prop="employeeName" label="员工姓名" :width="tableWidth[2] | translateWidth" show-overflow-tooltip></el-table-column>
        <el-table-column prop="idCard" label="证件号码" :width="tableWidth[3] | translateWidth" show-overflow-tooltip></el-table-column>
        <el-table-column prop="salaryDate" label="薪资月份" :width="tableWidth[4] | translateWidth" show-overflow-tooltip></el-table-column>
        <el-table-column prop="totalPayAmount" label="应发薪资" :width="tableWidth[5] | translateWidth" show-overflow-tooltip></el-table-column>
        <el-table-column prop="finalPayAmount" label="实发薪资" :width="tableWidth[6] | translateWidth" show-overflow-tooltip></el-table-column>
        <el-table-column prop="totalDeduction" label="扣款合计" :width="tableWidth[7] | translateWidth" show-overflow-tooltip></el-table-column>
        <el-table-column prop="incomeTax" label="个税金额" :width="tableWidth[8] | translateWidth" show-overflow-tooltip></el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="font_14_orange pointer view" @click="view(scope)">查看</span>
          </template>
        </el-table-column>
      </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, sizes, jumper, ->, slot"
        :total="this.total"
        :pager-count="5"
      ></el-pagination>
    </div>
    <!--  弹窗 -->
    <el-dialog title :visible.sync="mask" width="31%" center v-loading="loading">
      <h3 class="export-title font_16_black">薪资详情导出</h3>
      <div class="export-item">
        <p class="export-item-name font_14_black">所属企业</p>
        <el-select
          class="custom-os"
          v-model="mask_selectedValue"
          multiple
          filterable
          clearable
          default-first-option
          size="medium"
          placeholder="请选择组织或输入关键字搜索"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="export-item">
        <p class="export-item-name font_14_black">薪资类型</p>
        <el-select
          class="custom-os"
          v-model="type"
          multiple
          filterable
          clearable
          default-first-option
          size="medium"
          placeholder="请选择"
        >
          <el-option v-for="item in types" :key="item.value" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="export-item">
        <p class="export-item-name font_14_black">薪资月份</p>
        <el-date-picker class="custom-mc" v-model="mask_month" type="month" placeholder="选择月"></el-date-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="export_btn">
          <button-a
            padding="10px 128px"
            color="#fff"
            bgcolor="#f26828"
            @click.native="exportExcel()"
          >导出</button-a>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Get, Download } from "@/js/http.js";
import { Filter, dateConvert, translateWidth } from "@/js/tool.js";
import { Message } from "element-ui";
import { trackEvent, EVENT_CODE } from "@/js/analytics";

export default {
  name: "SalaryDetails",
  components: {},
  props: {},
  data() {
    return {
      tableWidth: [35, 250, 130, 200, 164, 140, 140, 140, 140],

      input: "", // 员工搜索输入
      salaryDateRange: [], // 薪资月份范围
      selectedValue: "",
      setType: {
        正常工资: true,
        劳务报酬: true,
        全年一次性奖金: true,
        解除劳动合同补偿金: true
      },
      options: [
        // 组织搜索框
      ],
      types: [
        { value: "正常工资" },
        { value: "劳务报酬" },
        { value: "全年一次性奖金" },
        { value: "解除劳动合同补偿金" }
      ],
      type: [],
      mask: false,
      mask_month: "",
      mask_selectedValue: [],
      page: 1, // 当前页码
      size: 10,
      tableData: [], // 表格数据
      total: 0,
      multipleSelection: [], // 表格行选择
      rowStyle: {
        // 表格内容行样式
        height: translateWidth(60) + "px",
        backgroundColor: "#fff"
      },
      headerRowStyle: {
        // 表格头行样式
        height: translateWidth(68) + "px",
        fongSize: "14px",
        color: "#000",
        backgroundColor: "#fafbff"
      },
      headerCellStyle: {
        // 表格头单元格样式
        backgroundColor: "transparent"
      },
      activeTab: "second", // 当前选择的选项卡
      loading: false,
      tableLoading: false, // 表格加载状态
      exportLoading: false, // 导出加载状态
      activeNames: [], // 展开的折叠面板
      
      // 交互相关
      clickTimer: null, // 单击定时器
      isDragging: false, // 是否正在拖动
      isDoubleClick: false // 是否双击
    };
  },
  watch: {},
  computed: {
    // 查询表格跳过的条数
    SkipCount() {
      return (this.page - 1) * this.size;
    }
  },
  methods: {
    change(dataName, key) {
      /*  this[dataName][key] = !this[dataName][key];
      this[dataName] = this[dataName].slice();
      this.updateTable(); */
      let ischanged = Filter.call(this, dataName, key);
      if (ischanged) {
        if (dataName === "setType") {
          const selectedSalaryTypes = Object.keys(this.setType).filter(type => this.setType[type]);
          trackEvent(EVENT_CODE.SALARY_BATCH_DETAIL_TYPE_SWITCH, {
            selectedSalaryTypes,
            changedSalaryType: key
          });
        }
        this.page = 1;
        this.getTableData();
      }
    },
    exportExcel() {
      this.loading = true;
      
      // 检查是否所有薪资类型都全选
      let isAllSetType = true;
      for (let key in this.setType) {
        if (!this.setType[key]) {
          isAllSetType = false;
          break;
        }
      }
      
      // 当所有薪资类型都全选时，需要输入其他查询条件
      if (isAllSetType && !this.input && !this.salaryDateRange[0] && !this.salaryDateRange[1]) {
        this.loading = false;
        Message.warning("请至少输入一个查询条件或选择一个筛选条件");
        return;
      }
      
      // 获取当前日期
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const dateStr = `${year}${month}${day}`;
      
      // 获取客户全称
      const customerName = localStorage.getItem('tenant_name') || localStorage.getItem('companyName') || '客户';
      
      let SetType = [];
      for (let i in this.setType) {
        if (this.setType[i] == true) {
          SetType.push(i);
        }
      }
      Download(
        "api/v1/employee-salaries/excel",
        {
          SalaryTypes: SetType,
          SalaryDateBegin: this.salaryDateRange[0],
          SalaryDateEnd: this.salaryDateRange[1],
          Keyword: this.input
        },
        `${customerName}-员工薪资-${dateStr}.xlsx`
      ).then(() => {
        this.loading = false;
      }).catch(err => {
        this.loading = false;
        Message.error('导出失败，请稍后重试');
        console.error('导出失败:', err);
      });
    },
    // 获取组织数据
    getOptions() {
      Get("api/v1/customers/selectors").then(({ data }) => {
        this.options = data;
      });
    },
    // 点击查询按钮
    query() {
      this.page = 1;
      this.getTableData();
    },
    reset() {
      this.selectedValue = "";
      this.input = "";
      this.salaryDateRange = [];
      // 重置薪资类型为全选
      for (let key in this.setType) {
        this.setType[key] = true;
      }
      this.page = 1;
      this.getTableData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getTableData() {
      this.tableLoading = true
      let SetType = [];
      for (let i in this.setType) {
        if (this.setType[i] == true) {
          SetType.push(i);
        }
      }
      
      // 处理薪资月份范围
      let salaryDateRange = this.salaryDateRange || [null, null]
      
      Get("api/v1/employee-salaries", {
        // customerId: this.selectedValue,
        Keyword: this.input,
        SalaryDateBegin: salaryDateRange[0], // 薪资月份起始
        SalaryDateEnd: salaryDateRange[1], // 薪资月份结束
        SalaryTypes: SetType,
        MaxResultCount: this.size, // 每页条数
        SkipCount: this.SkipCount // 跳过条数
      })
        .then(res => {
          this.total = res.data.totalCount;
          this.tableData = res.data.items;
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
        })
    },

    // 处理行点击（支持双击取消跳转、拖动选中不跳转）
    handleRowClick(scope) {
      const row = scope.row || scope;
      if (this.isDragging || this.isDoubleClick) {
        this.isDoubleClick = false;
        return;
      }
      if (this.clickTimer) {
        clearTimeout(this.clickTimer);
      }
      this.clickTimer = setTimeout(() => {
        this.view(row);
        this.clickTimer = null;
      }, 300);
    },
    // 处理双击
    handleRowDblclick(scope) {
      const row = scope.row || scope;
      if (this.clickTimer) {
        clearTimeout(this.clickTimer);
        this.clickTimer = null;
      }
      this.isDoubleClick = true;
      this.copyRowData(row);
    },
    // 处理鼠标按下
    handleRowMousedown() {
      this.isDragging = false;
    },
    // 处理鼠标移动
    handleRowMousemove() {
      this.isDragging = true;
    },
    // 处理鼠标释放
    handleRowMouseup() {
      setTimeout(() => {
        this.isDragging = false;
      }, 100);
    },
    // 复制行数据文本
    copyRowData(item) {
      const rowText = `所属企业: ${item.customerName || ''}\n员工姓名: ${item.employeeName || ''}\n证件号码: ${item.idCard || ''}\n薪资月份: ${item.salaryDate || ''}\n应发薪资: ${item.totalPayAmount || ''}\n实发薪资: ${item.finalPayAmount || ''}\n扣款合计: ${item.totalDeduction || ''}\n个税金额: ${item.incomeTax || ''}`;
      
      navigator.clipboard.writeText(rowText).then(() => {
        this.$message.success('已复制整行数据');
      }).catch(() => {
        const textarea = document.createElement('textarea');
        textarea.value = rowText;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.$message.success('已复制整行数据');
      });
    },
    // 查看
    view(payload) {
      const row = payload && payload.row ? payload.row : payload;
      const pkid = row && (row.id || row.pkid || row.employeeSalaryId);

      if (!pkid) {
        this.$message.error("薪资详情ID缺失，无法查看详情");
        console.error("[SalaryDetails] 无法跳转详情，缺少pkid：", payload);
        return;
      }

      this.$router.push({
        name: "SalaryDetailsItem",
        params: {
          pkid,
          setType: row.setType
        }
      });
    },
    // 日期格式转换
    date(dateStr) {
      return dateConvert(dateStr);
    },
    // 每页条数选择
    handleSizeChange(v) {
      this.size = v;
      this.getTableData();
    },
    // 页码选择
    handleCurrentChange(v) {
      this.page = v;
      this.getTableData();
    },
    translateWidth(num) {
      return translateWidth(num)
    },
    // 绑定窗口缩放事件
    ifResize() {
      window.addEventListener("resize", this.resize);
    },
    resize() {
      this.tableWidth = JSON.parse(JSON.stringify(this.tableWidth))
    }
  },
  created() {},
  mounted() {
    this.getOptions();
    this.getTableData();
  },
  activated() {
    this.ifResize();
  },
  deactivated() {
    // 解除事件
    window.removeEventListener('resize', this.resize)
  },
};
</script>

<style lang="scss" scoped>
// 布局样式
.wrapper {
  padding: 180px 32px 24px;
  > div {
    margin-bottom: 32px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  /* 默认布局 - 正常屏幕最大化时全部在同一行 */
  /* 默认布局 - 正常屏幕最大化时全部在同一行 */
  .filter {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 22px 48px;
    flex-wrap: wrap;
    position: fixed;
    top: 70px;
    left: 11.6vw;
    right: 0;
    z-index: 100;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    max-width: calc(100% - 11.6vw);
    border: 1px solid #e5e5e5;
    border-radius: 6px;
  }
  
  /* 第一行：员工姓名和薪资月份 */
  .filter-row-1 {
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
    flex-wrap: wrap;
    .custom-es {
      flex: 1;
      min-width: 100%;
      @media (min-width: 1200px) {
        min-width: 250px;
        flex: none;
      }
    }
    .date-group {
      display: flex;
      align-items: center;
      gap: 8px;
      flex: 1;
      min-width: 100%;
      @media (min-width: 1200px) {
        flex: none;
        min-width: auto;
      }
    }
  }
  
  /* 第二行：薪资类型和按钮 */
  .filter-row-2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
    flex-wrap: wrap;
    .button-group {
      flex: 1;
      justify-content: flex-end;
      @media (max-width: 1199px) {
        justify-content: flex-start;
      }
    }
  }
  
  .tag-group {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }
  
  .button-group {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  
  .options {
    display: flex;
    align-items: center;
  }
  
  .sum-group {
    display: flex;
    padding: 24px 48px 24px;
    align-items: center;
    .sum {
      width: 240px;
      &:last-of-type {
        flex: 1;
      }
    }
  }
  
  .result {
    padding: 30px 48px 48px;
  }
}

/* 响应式布局 - 屏幕缩小时分成三行 */
@media screen and (max-width: 1200px) {
  .filter {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    padding: 20px;
  }
  
  .filter-row-1,
  .filter-row-2,
  .filter-row-3 {
    width: 100%;
  }
  
  .filter-row-1 {
    flex-wrap: wrap;
  }
  
  .filter-row-2 {
    flex-wrap: wrap;
  }
  
  .filter-row-3 {
    justify-content: flex-start;
  }
  
  .tag-group {
    flex-wrap: wrap;
  }
}
/** 
  补充样式
*/
// 筛选标签
.filter-tag {
  margin-left: 6px;
  margin-right: 24px;
  min-width: 100px;
  text-align: center;
}
// 查询按钮
.query {
  margin-right: 32px;
}
// 导出按钮
.export {
  margin-right: 50px;
}
// 查看按钮
.view {
  margin-right: 18px;
}
// 通知详情按钮
.detail {
  margin-right: 18px;
}

// 属性面板
.infomation {
  display: flex;
  align-items: center;
  padding: 30px 84px;
}
.user_picture {
  margin-right: 64px;
}
// 键值对
.key-value {
  display: flex;
  justify-content: center;
  align-self: stretch;
  margin-right: 150px;
  &:last-child {
    margin-right: 0;
  }
  .key {
    margin-right: 50px;
    p {
      text-align: right;
    }
  }
  p {
    margin-bottom: 32px;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
}

// 小标签
.tag {
  margin-left: 16px;
}

// 选项卡
.el-tabs {
  ::v-deep .el-tabs__nav .el-tabs__item {
    padding: 0 49px;
    height: 64px;
    font-size: 16px;
    line-height: 64px;
    &.is-active {
      color: #f26828;
    }
    &:hover {
      color: #f26828;
    }
  }
  ::v-deep .el-tabs__active-bar {
    background-color: #f26828;
  }
}

// 轮播
.block {
  width: 1180px;
  .row {
    justify-content: center;
  }
  .contract {
    display: flex;
    align-items: center;
    width: 1020px;
    height: 450px;
    padding: 40px 35px;
    background-color: #fafbff;
    border-radius: 8px;
  }
  .tag {
    margin-left: 0;
    margin-right: 10px;
  }
  .pdf {
    display: flex;
    width: 168px;
    cursor: pointer;
  }
  .pdf_icon {
    margin-right: 15px;
  }
}

// 折叠面板
.fold {
  overflow: hidden;
  padding: 32px 64px;
  .el-collapse {
    border: none;
    .row {
      padding-top: 32px;
      padding-left: 50px;
    }
    ::v-deep .el-collapse-item__header {
      border: none;
      img {
        transition: all 0.6s ease;
      }
    }
    ::v-deep .el-collapse-item__wrap {
      border: none;
    }
    ::v-deep .el-collapse-item__content {
      padding-bottom: 0;
    }
    ::v-deep .el-collapse-item.is-active {
      img {
        transform: rotate(180deg);
        transition: all 0.6s ease;
      }
    }
    ::v-deep .el-collapse-item__arrow {
      display: none;
    }
  }
  .fold_title {
    display: flex;
    align-items: center;
    // padding-left: 64px;
    .money {
      width: 236px;
      height: 46px;
      margin-left: 40px;
      margin-right: 58px;
      line-height: 46px;
      text-align: center;
      background-color: #eff2fe;
      border-radius: 8px;
    }
    .fold_btn {
      display: flex;
      align-items: center;
      .fold_icon {
      }
    }
  }
}
// 补充样式
.wrapper .tags .tag-group[data-v-68b1054e]:last-child {
  margin-bottom: 0px;
  margin-left: -45px;
  margin-top: -35px;
}
</style>